import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client, BASE_URL } from '../api/client';
import { getThunkName, createThunkName, updateThunkName, deleteThunkName } from './base';
import { thunkPerformanceAchievementApi } from './performance-achievement';

export const thunkPerformanceIndicator = 'indikator-kinerja';
export const slicePerformanceAchievementName = 'kelola-indikator-kinerja';

// Indikator
export const getPerformanceIndicatorList = createAsyncThunk(getThunkName(thunkPerformanceIndicator), async (id, { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkPerformanceAchievementApi + '/' + id + '/' + thunkPerformanceIndicator, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const createPerformanceIndicator = createAsyncThunk(createThunkName(thunkPerformanceIndicator), async ({ id, body }, { rejectWithValue }) => {
  try {
    const response = await client.post(BASE_URL + thunkPerformanceAchievementApi + '/' + id + '/' + thunkPerformanceIndicator, body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const updatePerformanceIndicator = createAsyncThunk(updateThunkName(thunkPerformanceIndicator), async ({ id, body }, { rejectWithValue }) => {
  try {
    const response = await client.put(BASE_URL + thunkPerformanceAchievementApi + '/' + id + '/' + thunkPerformanceIndicator, body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const deletePerformanceIndicator = createAsyncThunk(deleteThunkName(thunkPerformanceIndicator), async ({ id }, { rejectWithValue }) => {
  try {
    const response = await client.delete(BASE_URL + thunkPerformanceAchievementApi + '/' + id + '/' + thunkPerformanceIndicator, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const PerformanceAchievementSlice = createSlice({
  name: slicePerformanceAchievementName,
  initialState: {
    get: {
      data: [],
      status: 'idle',
      message: '',
      error: '',
      pagination: {},
    },
    create: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    update: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    delete: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPerformanceIndicatorList.pending, state => {
        state.get.data = [];
        state.get.status = 'loading';
        state.get.message = '';
        state.get.error = '';
        state.get.pagination = {};
      })
      .addCase(getPerformanceIndicatorList.fulfilled, (state, action) => {
        state.get.data = action.payload.data;
        state.get.status = 'succeeded';
        state.get.message = action.payload.message;
        state.get.error = '';
        state.get.pagination = action.payload.meta;
      })
      .addCase(getPerformanceIndicatorList.rejected, (state, action) => {
        state.get.data = [];
        state.get.status = 'failed';
        state.get.message = action.payload.message;
        state.get.error = action.payload.error;
        state.get.pagination = {};
      })
      .addCase(createPerformanceIndicator.pending, state => {
        state.create.data = {};
        state.create.status = 'loading';
        state.create.message = '';
        state.create.error = '';
      })
      .addCase(createPerformanceIndicator.fulfilled, (state, action) => {
        state.create.data = action.payload.data;
        state.create.status = 'succeeded';
        state.create.message = action.payload.message;
        state.create.error = '';
      })
      .addCase(createPerformanceIndicator.rejected, (state, action) => {
        state.create.data = {};
        state.create.status = 'failed';
        state.create.message = action.payload.message;
        state.create.error = action.payload.error;
      })
      .addCase(updatePerformanceIndicator.pending, state => {
        state.update.data = {};
        state.update.status = 'loading';
        state.update.message = '';
        state.update.error = '';
      })
      .addCase(updatePerformanceIndicator.fulfilled, (state, action) => {
        state.update.data = action.payload.data;
        state.update.status = 'succeeded';
        state.update.message = action.payload.message;
        state.update.error = '';
      })
      .addCase(updatePerformanceIndicator.rejected, (state, action) => {
        state.update.data = {};
        state.update.status = 'failed';
        state.update.message = action.payload.message;
        state.update.error = action.payload.error;
      })
      .addCase(deletePerformanceIndicator.pending, state => {
        state.delete.data = {};
        state.delete.status = 'loading';
        state.delete.message = '';
        state.delete.error = '';
      })
      .addCase(deletePerformanceIndicator.fulfilled, (state, action) => {
        state.delete.data = action.payload.data;
        state.delete.status = 'succeeded';
        state.delete.message = action.payload.message;
        state.delete.error = '';
      })
      .addCase(deletePerformanceIndicator.rejected, (state, action) => {
        state.delete.data = {};
        state.delete.status = 'failed';
        state.delete.message = action.payload.message;
        state.delete.error = action.payload.error;
      })
  },
});

export default PerformanceAchievementSlice.reducer;
